import React from 'react';
import mapboxgl from 'mapbox-gl';
import './ZoomControl.scss'; // Import the CSS file for styling

interface ZoomControlProps {
  map: mapboxgl.Map;
}

const ZoomControl: React.FC<ZoomControlProps> = ({ map }) => {
  const handleZoomIn = () => {
    map.zoomIn();
  };

  const handleZoomOut = () => {
    map.zoomOut();
  };

  return (
    <div className="zoom-control map-control">
      <button className="zoom-button control-button" title='Zoom in one zoom level' onClick={handleZoomIn}>+</button>
      <button className="zoom-button control-button" title='Zoom out one zoom level' onClick={handleZoomOut}>-</button>
    </div>
  );
};

export default ZoomControl;